import React, { useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { useNavigate } from "react-router-dom";

const InvoiceTab = ({ index, id }: any) => {
  const [activeIndex, setActiveIndex] = useState<number>(index);

  const navigate = useNavigate();

  const tabChange = (e: any) => {
    setActiveIndex(e.index);

    if (e?.index === 0) {
      navigate("/invoice-payee", { state: { clientId: id } });
    } else {
      navigate("/invoice-list", { state: { clientId: id } });
    }
  };

  return (
    <>
      <TabView activeIndex={activeIndex} onTabChange={(e) => tabChange(e)}>
        <TabPanel header="Payee"></TabPanel>
        <TabPanel header="Invoice"></TabPanel>
      </TabView>
    </>
  );
};

export default InvoiceTab;
